import { UserManager } from 'oidc-client';
import { storeUser, unloadUser, storeClaims, authNegotiate } from '../slices/global/authSlice';
import axios from 'axios';
import { createCookie } from './utils';

const config = {
  authority: 'https://identity.autoshack.com',
  client_id: process.env.REACT_APP_CLIENT_ID,
  redirect_uri: process.env.REACT_APP_REDIRECT_URI + '/signin-oidc',
  response_type: 'id_token token',
  scope: `openid profile ${process.env.REACT_APP_SCOPE} ${process.env.REACT_APP_KAP_TMS_SCOPE}`,
  post_logout_redirect_uri: process.env.REACT_APP_LOGOUT_REDIRECT_URI + '/signout-oidc',
  popupWindowFeatures: 'width=550,height=650',
};

const userManager = new UserManager(config);

export async function getRoleClaims(store, user) {
  //Reset claims
  store.dispatch(storeClaims(null));

  await axios
    .get(
      `https://identity.autoshack.com/AccountManager/RoleClaimsByRole?roleId=${user.profile.role}`,
    )
    .then((response) => store.dispatch(storeClaims(response.data)))
    .catch(function (err) {
      if (err.message !== 'canceled') store.dispatch(storeClaims(null));
    });
}

export async function loadUserFromStorage(store) {
  try {
    let user = await userManager.getUser();
    if (!user) {
      return store.dispatch(unloadUser());
    }
    store.dispatch(authNegotiate());
    await getRoleClaims(store, user).then(() => store.dispatch(storeUser(user)));
    createCookie('roleId', user.profile.role, 1);
    createCookie('username', user.profile.email, 1);
  } catch (e) {
    console.error(`User not found: ${e}`);
    store.dispatch(unloadUser());
  }
}

export async function signinRedirect(handleError) {
  try {
    console.log(config);
    return await userManager.signinPopup();
  } catch {
    handleError();
  }
}

export function signinRedirectCallback() {
  return userManager.signinPopupCallback();
}

export function signoutRedirect() {
  userManager.clearStaleState();
  userManager.removeUser();
  return userManager.signoutRedirect();
}

export function signoutRedirectCallback() {
  userManager.clearStaleState();
  userManager.removeUser();
  return userManager.signoutRedirectCallback();
}

export default userManager;
